myjQuery(document).ready(function($) {
    // Listen for changes on shipping_option radio buttons using event delegation
    $('body').on('change', 'input[name="shipping_option"]', function() {
        // Get values from the ss_ fields
        var cityValue = $('input[name="ss_city"]').val();
        var stateValue = $('select[name="ss_state"]').val();
        var zipValue = $('input[name="ss_zip"]').val();
        
        // Fill/select the corresponding fields in the shipping address form
        $('input[name="city"]').val(cityValue);
        $('select[name="region_id"]').val(stateValue);
        $('input[name="zip"]').val(zipValue);
        
        // Make the fields readonly
        $('input[name="city"]').attr('readonly', true);
        $('select[name="region_id"]').css('pointer-events', 'none').css('background-color', '#f6f9fc');
        $('input[name="zip"]').attr('readonly', true);
        
        // Remove the "SELECT OPTION" list item
        $('li.list-group-item-select-option').remove();
        
        // Remove .list-group-item-warning from all li elements in the parent ul
        $(this).closest('ul').find('li').removeClass('list-group-item-warning');
        
        // Add .list-group-item-warning to the parent li
        $(this).closest('li').addClass('list-group-item-warning');
        
        // Make the divs visible by removing the d-none class
        $('#shippingAddress').removeClass('d-none');
        $('#shippingPDate').removeClass('d-none');
        $('#shippingControl').removeClass('d-none');
    });
    
    // When changing ss_city, ss_state or ss_zip, empty div.shipping-rates
    $('body').on('change', 'input[name="ss_city"], select[name="ss_state"], input[name="ss_zip"]', function() {
        $('div.shipping-rates').empty();
    });
    
    // When clicking 'show rates' button, empty div.shipping-rates
    $('body').on('click', '.btn-get-rates', function() {
        $('div.shipping-rates').empty();
    });
});